import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import PromptBox from "./PromptBox";
import { useTranslation } from "react-i18next";

export function RouterPrompt(props) {
  const { when, onOK, onCancel } = props;

  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState("");
  const [translation] = useTranslation("translations");

  useEffect(() => {
    if (when) {
      history.block((prompt) => {
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
        return "true";
      });
    } else {
      history.block(() => {});
    }

    return () => {
      history.block(() => {});
    };
  }, [history, when]);

  const handleOK = useCallback(async () => {
    if (onOK) {
      const canRoute = await Promise.resolve(onOK());
      if (canRoute) {
        history.block(() => {});
      }
    }
    setShowPrompt(false);
    onCancel();
  }, [history, onOK, onCancel]);

  const handleCancel = useCallback(() => {
    history.block(() => {});
    history.push(currentPath);
    setShowPrompt(false);
  }, [currentPath, history]);

  return showPrompt ? (
    <PromptBox
      show={showPrompt}
      handleClosePrompt={handleCancel}
      title={translation("changes_not_saved")}
      message={translation("back_options_description")}
      handleClose={handleCancel}
      handleSave={handleOK}
    />
  ) : null;
}
